import React, { useCallback } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { toast } from 'react-toastify';
import { Typography } from '@material-ui/core';
import { useDeleteAppointment } from '../../../../../../hooks/data/appointments';
import { IAppointmentDTO } from '../../../../../../shared/interfaces/appointment-interfaces';

type IProps = {
  open: boolean;
  handleClose: () => void;
  appointment: IAppointmentDTO;
};

const AppointmentDeleteDialog: React.FC<IProps> = ({
  open,
  handleClose,
  appointment,
}) => {
  const deleteAppointment = useDeleteAppointment({ id: appointment.id! });

  const handleSubmit = useCallback(async () => {
    try {
      await deleteAppointment.mutateAsync({});

      handleClose();
      toast.success('Agendamento excluído com sucesso');
    } catch (err) {
      toast.error('Erro ao excluir agendamento');
    }
  }, [deleteAppointment, handleClose]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">
        Deseja excluir o agendamento?
      </DialogTitle>
      <DialogContent>
        <Typography>{`Cliente: ${appointment.customer_name}`}</Typography>
        <Typography>{`Serviço: ${appointment.service.service_name}`}</Typography>
        <Typography>{`Horário: ${appointment.start_time}`}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancelar
        </Button>
        <Button onClick={handleSubmit} color="primary" variant="contained">
          Excluir
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export { AppointmentDeleteDialog };
